import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectUserLoading, selectUser } from '../../redux/selectors';
import { tokenStorage } from 'utils';
import Loader from 'components/Loader';
import { canAccessByPermission } from './routes';

const ProtectedRoute = ({ children, permission, adminOnly, requiredPermission }) => {
  const userRole = useSelector((state) => state.reducer.role);
  const isAdmin = useSelector((state) => state.reducer.isAdmin);
  const userLoading = useSelector(selectUserLoading);
  const user = useSelector(selectUser);
  const location = useLocation();

  const token = tokenStorage.get();

  // Если есть токен, но пользователь еще не загружен - показываем лоадер
  // Это позволяет дождаться загрузки данных пользователя перед проверкой прав
  // Показываем лоадер, если:
  // 1. Есть токен
  // 2. Пользователь еще не загружен (null)
  // 3. Идет загрузка или еще не началась (useAuth запустит загрузку)
  if (token && !user && userLoading) {
    return <Loader />;
  }

  // Если нет токена и нет пользователя - редиректим на логин
  if (!token && !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Если есть токен, но пользователь не загружен и загрузка не идет
  // Это может означать ошибку загрузки или что загрузка еще не началась
  // Даем небольшой буфер времени для запуска загрузки через useAuth
  if (token && !user && !userLoading) {
    // Небольшая задержка, чтобы дать useAuth время запустить загрузку
    // В большинстве случаев useAuth запустит загрузку до этого рендера
    // Но если этого не произошло, показываем лоадер на короткое время
    return <Loader />;
  }

  // Проверяем админские права только после загрузки данных пользователя
  if (adminOnly) {
    if (!isAdmin) {
      return <Navigate to="/chat" state={{ from: location }} replace />;
    }
  }

  if (requiredPermission && !canAccessByPermission(userRole, isAdmin, requiredPermission)) {
    return <Navigate to="/chat" state={{ from: location }} replace />;
  }

  // Если нет ограничений по ролям, показываем компонент
  if (!permission || permission.length === 0) {
    return children;
  }

  // Проверяем, есть ли у пользователя нужная роль
  if (!permission.includes(userRole)) {
    // Редиректим на первую доступную страницу или чат
    return <Navigate to="/chat" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
